import { ethers, providers, utils } from "ethers";
import Baroque_Works_ABI from "../lib/abi/BaroqueWorks.json";
import DAI_ABI from "../lib/abi/ERC20DAI.json";

// const RPC_URL = "http://127.0.0.1:8545";
const RPC_URL = "https://goerli.infura.io/v3/";
// const NETWORK_ID = 31337;
const NETWORK_ID = 5;

export const DAI_ADDRESS = "0x65aDffA512C0c7c69341EfebCFABe3f3aDD17443";
export const BAROQUE_WORKS_ADDRESS = "0xC30eec15298829b233a2140711265Fe295E6c330";

type ConnectDescription = {
	address: string;
	chainId: number;
};

type Connects = {
	networkId: number;
	web3Provider: any;
	rpcProvider: any;
	signers: any;

	init: () => Promise<any>;
	connect: () => Promise<ConnectDescription | undefined>;
	clear: () => void;
	pushGoarli: () => void;
};

export const connects: Connects = {
	networkId: NETWORK_ID, //Goerli
	web3Provider: {},
	rpcProvider: {},
	signers: {},

	async init() {
		const provider = new providers.JsonRpcProvider(RPC_URL, this.networkId);
		const daiContract = new ethers.Contract(DAI_ADDRESS, DAI_ABI, provider);
		const BaroqueWorksContract = new ethers.Contract(
			BAROQUE_WORKS_ADDRESS,
			Baroque_Works_ABI,
			provider
		);
		this.rpcProvider["DAI"] = daiContract;
		this.rpcProvider["BaroqueWorks"] = BaroqueWorksContract;
	},

	async connect() {
		if (window.ethereum) {
			const provider = new providers.Web3Provider(window.ethereum, "any");
			const address = await provider.send("eth_requestAccounts", []);
			const chainId = await provider.getNetwork().then((res) => res.chainId);
			const signer = provider.getSigner();

			this.signers["DAI"] = new ethers.Contract(DAI_ADDRESS, DAI_ABI, signer);
			this.signers["BaroqueWorks"] = new ethers.Contract(
				BAROQUE_WORKS_ADDRESS,
				Baroque_Works_ABI,
				signer
			);

			const connectDescription = {
				address: address[0],
				chainId: chainId,
			};

			return connectDescription;
		} else {
			alert("Please download Metamask!");
		}
	},

	async clear() {
		this.signers = {};
	},

	pushGoarli() {
		window.ethereum.request({
			method: "wallet_addEthereumChain",
			params: [
				{
					chainId: utils.hexValue(this.networkId),
					rpcUrls: [RPC_URL],
					chainName: `${this.networkId === 5 ? "Goarli" : "Ethereum"}`,
					nativeCurrency: {
						name: "ETH",
						symbol: "ETH",
						decimals: 18,
					},
					blockExplorerUrls: ["https://goerli.etherscan.io/"],
				},
			],
		});
	},
};
